import { Link, useLocation } from "react-router-dom";
import moment from 'moment-timezone'; // For timezone handling
import { useEffect, useState } from "react";

export default function CourseTableRow({ data }) {
  const [timeRemaining, setTimeRemaining] = useState('');
  const location = useLocation();
  const isAppRoute = location.pathname.startsWith("/app");

  useEffect(() => {
    if (!data?.start_time) {
      setTimeRemaining('—');
      return;
    }
    const courseStartTimeUtc = moment.tz(data?.start_time, 'UTC');
    const interval = setInterval(() => {
      const now = moment(); // Current local time
      const diff = moment.duration(courseStartTimeUtc.diff(now)); // Difference between now and course start time

      if (diff.asSeconds() <= 0) {
        clearInterval(interval);
        setTimeRemaining('00:00:00');
      } else {
        const hours = String(Math.floor(diff.asHours())).padStart(2, '0');
        const minutes = String(diff.minutes()).padStart(2, '0');
        const seconds = String(diff.seconds()).padStart(2, '0');
        setTimeRemaining(`${hours}:${minutes}:${seconds}`);
      }
    }, 1000);

    return () => clearInterval(interval); // Clean up on component unmount
  }, []);
  return (
    <>
      <tr className="align-middle">
        <td data-label="Type">{data?.course?.course_type == 'recorded' ? 'Recorded' : 'Live'}</td>
        <td data-label="Student">{data?.student?.name}</td>
        <td data-label="Course">
          <div className="table-course-detail">
            <Link to={isAppRoute?`/app/course/${data?.course?.slug}`:`/course/${data?.course?.slug}`} className="course-table-img text-info">
              {/* <span><img src={data?.course?.cover_image} alt={data?.course?.title} /></span> */}
              {data?.course?.title}
            </Link>
          </div>
        </td>
        <td data-label="Lesson">{data?.lesson?.title}</td>
        <td data-label="Start Time">{data?.teacher_local_start_time}</td>
        <td className="fw-bold" data-label="Remaining">

          {data?.course?.course_type == 'recorded' ? '' : timeRemaining}

        </td>
       
        <td className="td-actions">
          <div className="table-row-actions">
            {data?.course?.course_type != 'recorded' && data?.room_no ?
              <Link to={`/room/${data?.course?.slug}/${data?.room_no}`} className="row-action-btn primary" title="Start the live class">
                <i className="fa-light fa-video" />Start
              </Link>
              : ''
            }
            <Link to={isAppRoute?`/app/dashboard/enrollment-details/${data?.id}`:`/dashboard/enrollment-details/${data?.id}`} className="row-action-btn" title="View enrollment details">
              <i className="fa-light fa-eye" />Details
            </Link>
          </div>
        </td>
      </tr>
    </>
  )
}